/* eslint-disable */
// adapted from the first part of the the snippet provided here: https://websdk.appsflyer.com?st=banners
function script(e) {
  var t = {}
  function __webpack_require__(r) {
    if (t[r]) return t[r].exports
    var n = (t[r] = { i: r, l: !1, exports: {} })
    return (
      e[r].call(n.exports, n, n.exports, __webpack_require__),
      (n.l = !0),
      n.exports
    )
  }
  ;(__webpack_require__.m = e),
    (__webpack_require__.c = t),
    (__webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) ||
        Object.defineProperty(e, t, { enumerable: !0, get: r })
    }),
    (__webpack_require__.r = function (e) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 })
    }),
    (__webpack_require__.t = function (e, t) {
      if ((1 & t && (e = __webpack_require__(e)), 8 & t)) return e
      if (4 & t && 'object' == typeof e && e && e.__esModule) return e
      var r = Object.create(null)
      if (
        (__webpack_require__.r(r),
        Object.defineProperty(r, 'default', { enumerable: !0, value: e }),
        2 & t && 'string' != typeof e)
      )
        for (var n in e)
          __webpack_require__.d(
            r,
            n,
            function (t) {
              return e[t]
            }.bind(null, n),
          )
      return r
    }),
    (__webpack_require__.n = function (e) {
      var t =
        e && e.__esModule
          ? function getDefault() {
              return e.default
            }
          : function getModuleExports() {
              return e
            }
      return __webpack_require__.d(t, 'a', t), t
    }),
    (__webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
    }),
    (__webpack_require__.p = ''),
    __webpack_require__((__webpack_require__.s = 2))
}

const e = [
  function (e, t, r) {
    'use strict'
    var n = {},
      i = {}
    var a = /^([a-zA-Z0-9])([a-zA-Z0-9.+-]*):\/\/([^\s]+)?$/
    var o = /[\\\/*!@#?$%^&~`=+'";:\s><]/,
      s = /^undefined$|^null$|^NaN$|^arg$/,
      d = /[;$><^# `]/,
      u = /%3E|%3C|%24|%3B|%5E|%20|%60|%23/
    function _getValidParams(e) {
      var t,
        r,
        n = Object.keys(e),
        i = {},
        a = 10
      n.length < a && (a = n.length)
      for (var l = 0; l < a; l++) {
        var c = n[l]
        !(r = c) ||
          s.test(r) ||
          o.test(r) ||
          (!(t = e[c]) && 0 !== t && !1 !== t) ||
          ('string' != typeof t &&
            'number' != typeof t &&
            'boolean' != typeof t) ||
          u.test(t) ||
          d.test(t) ||
          (i[c] = e[c])
      }
      return i
    }
    e.exports = {
      after: function _after(e, t) {
        if (e < 0) throw new Error('Invalid argument count')
        if ('function' != typeof t) throw new Error('Invalid argument callback')
        var r = []
        return function () {
          var n = Array.prototype.slice.call(arguments)
          if ((r.push(n), 0 == (e -= 1))) return t(r)
        }
      },
      pickUrlValues: function _pickUrlValues(e) {
        var t,
          r = []
        for (var n in e)
          e.hasOwnProperty(n) && ((t = e[n]), a.test(t)) && r.push(e[n])
        return r
      },
      timeLimitCallback: function _timeLimitCallback(e, t, r) {
        var n = !1,
          i = window.setTimeout(function () {
            ;(n = !0), r && r()
          }, e)
        return function () {
          window.clearTimeout(i), n || t.apply(this, arguments)
        }
      },
      getAdditionalParams: function _getAdditionalParams() {
        return Object.assign({}, n)
      },
      setAdditionalParams: function _setAdditionalParams(e) {
        e && (n = Object.assign({}, e))
      },
      resetAdditionalParams: function _resetAdditionalParams() {
        n = {}
      },
      getValidParams: _getValidParams,
      getUpdateParams: function _getUpdateParams() {
        return Object.assign({}, i)
      },
      setUpdateParams: function _setUpdateParams(e) {
        var t = !!e && _getValidParams(e)
        t
          ? ((i = Object.assign({}, t)),
            window.AF_SDK.utils.logger('update params - success'))
          : window.AF_SDK.utils.logger(
              'update params - failure: the sent parameters are invalid',
            )
      },
      resetUpdateParams: function _resetUpdateParams() {
        i = {}
      },
    }
  },
  function (e, t, r) {
    'use strict'
    var n = r(0),
      i = 'AF_FREQUENCY_CAPPING',
      a = 'AF_BANNERS_DISMISSAL',
      o = 'AF_BANNERS_SESSION_ID',
      s = 'AF_BANNERS_URL_QUERY',
      d = 'AF_BANNERS_URL_EXP',
      u = 'https://fvalid.appsflyer.com/af/cp.sdk.1.2.7.js'
    function generateUTMParams(e, t) {
      return Object.assign(
        {},
        e && t ? { c: e } : {},
        t ? { pid: t, af_banner_build: 'utm' } : { af_banner_build: 'static' },
        { af_banner_config: 'utm' },
      )
    }
    var l = { af_channel: 'af_web_banner', pid: 'af_banner' },
      c = ['af_banner', 'af_banner_sdk_ver']
    e.exports = {
      initSession: function _initSession() {
        window.AF_SDK.utils.session.getItem(o) ||
          window.AF_SDK.utils.session.setItem(
            o,
            new Date().getTime().toString(),
          )
      },
      updateUrlQueryStorage: function _updateUrlQueryStorage() {
        var e = window.AF_SDK.utils.getUrlParamsObject({}),
          t = Boolean(e.pid || e.utm_source),
          r = window.AF_SDK.utils.storage.getItem(d, {})
        t
          ? (window.AF_SDK.utils.storage.setItem(s, location.search),
            window.AF_SDK.utils.storage.setItem(d, new Date().getTime() + 72e5))
          : r &&
            r < new Date() &&
            (window.AF_SDK.utils.storage.removeItem(d),
            window.AF_SDK.utils.storage.removeItem(s))
      },
      canDisplayBanner: function _canDisplayBanner(e) {
        var t =
            -1 !== e.frequency_capping &&
            (window.AF_SDK.utils.storage.getItem(i, {})[e.id] || 0) >=
              e.frequency_capping,
          r = !1,
          n = window.AF_SDK.utils.storage.getItem(a, {})[e.id]
        if (n && e.dismissal)
          switch (e.dismissal.type) {
            case 'never':
              r = !0
              break
            case 'period':
              r = new Date().getTime() - n < e.dismissal.value
              break
            case 'nextSession':
              r = n === window.AF_SDK.utils.session.getItem(o)
          }
        return !t && !r
      },
      updateBannerDismissalInfo: function _updateBannerDismissalInfo(e) {
        var t = window.AF_SDK.utils.storage.getItem(a, {})
        'nextSession' === e.dismissal.type
          ? (t[e.id] = window.AF_SDK.utils.session.getItem(o))
          : (t[e.id] = new Date().getTime().toString()),
          window.AF_SDK.utils.storage.setItem(a, t)
      },
      updateBannerFrequencyCapping: function _updateBannerFrequencyCapping(
        e,
        t,
      ) {
        if (!t && e.frequency_capping) {
          var r = window.AF_SDK.utils.storage.getItem(i, {})
          ;(r[e.id] = (r[e.id] || 0) + 1),
            window.AF_SDK.utils.storage.setItem(i, r)
        }
      },
      buildUrlQueryString: function _buildUrlQueryString(e, t) {
        for (
          var r = (function _extractDynamicParams(e) {
              var t = window.AF_SDK.utils.storage.getItem(s) || '',
                r = window.AF_SDK.utils.getUrlParamsObject({ search: t }),
                n = r.utm_source,
                i = r.utm_campaign
              switch (e) {
                case 'utm':
                  return Object.assign({}, generateUTMParams(i, n), {
                    af_banner_config: 'utm',
                  })
                case 'partner':
                case 'forward':
                  return r.pid
                    ? Object.assign({}, r, {
                        af_banner_build: 'forward',
                        af_banner_config: 'forward',
                      })
                    : { af_banner_build: 'static', af_banner_config: 'forward' }
                case 'forward_utm':
                  return r.pid
                    ? Object.assign({}, r, {
                        af_banner_build: 'forward',
                        af_banner_config: 'forward_utm',
                      })
                    : Object.assign({}, generateUTMParams(i, n), {
                        af_banner_config: 'forward_utm',
                      })
                case 'banner':
                default:
                  return {
                    af_banner_build: 'static',
                    af_banner_config: 'static',
                  }
              }
            })(e.attribution_method),
            i = n.getAdditionalParams(),
            a = n.getUpdateParams(),
            o = Object.assign({}, a, l, e.url.params, i, r),
            d = 0;
          d < c.length;
          d++
        )
          delete o[c[d]]
        return (
          t && (o['af-sb-preview'] = !0),
          (o.af_banner_sdk_ver = '2'),
          Object.keys(o)
            .map(function (e) {
              return '&' + e + '=' + o[e]
            })
            .join('')
        )
      },
      isSDKDisabled: function _isSDKDisabled() {
        return (
          'true' === window.AF_SDK.utils.getUrlParamsObject({})['af-sb-disable']
        )
      },
      fetchCpSdk: function _fetchCpSdk() {
        if (
          'https:' === document.location.protocol &&
          !window.AF_SDK.PLUGINS.BANNERS.getClickValidationToken
        ) {
          var e = document.createElement('script')
          ;(e.src = u),
            (e.onload = function () {
              window.onAFReady = function (e) {
                window.AF_SDK.PLUGINS.BANNERS.getClickValidationToken =
                  e.getToken.bind(e)
              }
            })
          var t = document.getElementsByTagName('script')[0]
          t.parentNode.insertBefore(e, t)
        }
      },
    }
  },
  function (e, t, r) {
    'use strict'
    var n = r(3),
      i = r(0),
      a = r(4),
      o = r(5),
      s = r(1),
      d = r(8),
      u = r(9),
      l = (window.AF_cleanupMethods = window.AF_cleanupMethods || [])
    function _init() {
      s.initSession(), s.updateUrlQueryStorage()
    }
    function _displayBanner(e, t) {
      ;(t = t || {}).key
      var r = a.prefetchAssets(e.creative.prefetch_urls, function (r) {
        if (r)
          window.AF_SDK.utils.logger('failed loading assets, banner is hidden'),
            _hideBanner()
        else
          try {
            var n = o.render(e.creative, t)
            d.injectPixel(e), l.push(n)
            var i = document.body.querySelector('[data-af-cta-button]')
            ;(document.body.querySelector('[data-af-close-button]').onclick =
              (function _getHideBannerHandler(e, t, r) {
                return !r && t.dismissal
                  ? function () {
                      s.updateBannerDismissalInfo(t), _hideBanner()
                    }
                  : _hideBanner
              })(0, e, t.preview)),
              (function _setQaAttributes(e, t, r) {
                var n = e.url.path + s.buildUrlQueryString(e, t)
                r.setAttribute('data-af-cta-url', n)
              })(e, t.preview, i),
              (i.onclick = (function _getBannerClickedHandler(e, t) {
                return function (r) {
                  var n = e.url.path + s.buildUrlQueryString(e, t),
                    i = ''
                  if (
                    (window.AF_SDK.utils.logger('oneLink URL: ' + n),
                    window.AF_SDK.PLUGINS.BANNERS.getClickValidationToken)
                  )
                    try {
                      i =
                        window.AF_SDK.PLUGINS.BANNERS.getClickValidationToken(r)
                    } catch (e) {
                      window.AF_SDK.utils.logger(
                        'error - failed to generate token: ' + e,
                      )
                    }
                  window.location.href = n + '&af_token=' + i + '&'
                }
              })(e, t.preview)),
              s.updateBannerFrequencyCapping(e, t.preview)
          } catch (e) {
            _hideBanner(), window.AF_SDK.utils.logger(e)
          }
      })
      l.push(r)
    }
    function _showBanner(e) {
      if (((e = e ? e.data : {}), u.any)) {
        var t = document.createElement('p')
        if (((t.style.display = 'flex'), 'flex' === t.style.display))
          if (s.isSDKDisabled())
            window.AF_SDK.utils.logger(
              'SDK is disabled by query param af-sb-disable.',
            )
          else {
            _hideBanner(), i.setAdditionalParams(e.additionalParams)
            var r =
              e.key ||
              (window.AF_SDK.initPluginsConfig.banners &&
                window.AF_SDK.initPluginsConfig.banners.key)
            if (r) {
              var a = { key: r },
                o = window.AF_SDK.utils.getUrlParamsObject({})['af-sb-id'],
                d = o || e.creativeId || e.bannerId
              d && (a.creativeId = d),
                o
                  ? n.getBannerForPreview(a, function (t, r) {
                      if (!t && r && r.length && r[0]) {
                        var i = r[0]
                        n.getBannerAsset(i.creative_url, function (t, n) {
                          !t &&
                            n &&
                            _displayBanner(
                              Object.assign(r[0], { creative: n }),
                              e,
                            )
                        })
                      }
                    })
                  : n.getBanners(a, function (t, r) {
                      !t &&
                        r &&
                        r.length &&
                        (function _getBannersAssets(e, t, r) {
                          for (var i = 0; i < e.length; i++) {
                            var a = e[i]
                            if (s.canDisplayBanner(a) && a.creative_url) {
                              n.getBannerAsset(a.creative_url, function (e, t) {
                                !e &&
                                  t &&
                                  _displayBanner(
                                    Object.assign(a, { creative: t }),
                                    r,
                                  )
                              })
                              break
                            }
                            window.AF_SDK.utils.logger(
                              'Banner [' +
                                a.id +
                                '] could not be displayed due to it`s frequency cap or dismissal rules',
                            )
                          }
                        })(r, 0, e)
                    })
            } else
              window.AF_SDK.utils.logger(
                'key param must be provided for getting banners from the server',
              )
          }
        else
          window.AF_SDK.utils.logger(
            "We detected a browser that doesn't support flex, displaying banners in this browser is disabled.",
          )
      } else
        window.AF_SDK.utils.logger(
          'We detected a non-mobile browser, displaying banners in this browser is disabled.',
        )
    }
    function _hideBanner() {
      if (l.length) {
        window.AF_SDK.utils.logger('Removing displayed banner from the page...')
        for (var e = 0; e < l.length; e++) l[e]()
        window.AF_cleanupMethods = l = []
      }
      i.resetAdditionalParams(), i.resetUpdateParams()
    }
    function _safeExport(e) {
      return Object.keys(e).reduce(function (t, r) {
        return (
          (t[r] = (function _safeExec(e, t) {
            return e && 'function' == typeof e
              ? function () {
                  try {
                    return e.apply(null, arguments)
                  } catch (e) {
                    console.log('error', e)
                  }
                }
              : e
          })(e[r])),
          t
        )
      }, {})
    }
    function _updateParams(e) {
      var t = e ? e.data : {}
      i.setUpdateParams(t)
    }
    window.AF.plugins.BANNERS = _safeExport({
      load: _init,
      showBanner: _showBanner,
      hideBanner: _hideBanner,
      updateParams: _updateParams,
      VERSION: '0.0.44',
    })
  },
  function (e, t, r) {
    'use strict'
    var n = 'https://banner.appsflyer.com/'
    e.exports = {
      getBanners: function _getBanners(e, t) {
        var r = n
        if (e && e.key) {
          var i = r + 'sb/' + e.key + '/creative/list'
          e.creativeId && (i += '?creativeId=' + e.creativeId),
            window.AF_SDK.xhr({
              method: 'POST',
              url: i,
              body: {
                'af-full-referer': window.location && window.location.href,
              },
              data: e,
              withCredentials: !1,
              cb: function (r) {
                if (!r || !r.data) {
                  var n = "fetch banners didn't return data"
                  return (
                    window.AF_SDK.utils.logger(
                      'Getting creatives for key [' +
                        e.key +
                        '] from the server... received, error: ',
                      n,
                    ),
                    t && t({ text: n })
                  )
                }
                window.AF_SDK.utils.logger(
                  'Getting creatives for key [' +
                    e.key +
                    '] from the server... received: ',
                  r,
                ),
                  t && t(null, r.data)
              },
              fail: function (r) {
                return (
                  window.AF_SDK.utils.logger(
                    'Getting creatives for key [' +
                      e.key +
                      '] from the server... received, error: ',
                    r,
                  ),
                  t && t(r)
                )
              },
            })
        } else
          window.AF_SDK.utils.logger(
            'Could not retrieve creatives, no key (mandatory) provided',
          )
      },
      getBannerForPreview: function _getBannerForPreview(e, t) {
        var r = n
        e && e.key && e.creativeId
          ? window.AF_SDK.xhr({
              method: 'GET',
              withCredentials: !1,
              url: r + 'sb/' + e.key + '/creative/' + e.creativeId + '/preview',
              cb: function (r, n) {
                if (!r || !r.data) {
                  var i = "fetch banner preview didn't return data"
                  return (
                    window.AF_SDK.utils.logger(
                      'Getting creative [' +
                        e.creativeId +
                        '] from the server... received, error: ',
                      i,
                    ),
                    t && t({ text: i })
                  )
                }
                window.AF_SDK.utils.logger(
                  'Getting creative [' +
                    e.creativeId +
                    '] from the server... received: ',
                  r.data[0],
                ),
                  r && t && t(null, r.data)
              },
              fail: function (r) {
                return (
                  window.AF_SDK.utils.logger(
                    'Getting creative [' +
                      e.creativeId +
                      '] from the server... received, error: ',
                    r,
                  ),
                  t && t(r)
                )
              },
            })
          : window.AF_SDK.utils.logger(
              'Could not retrieve creative, no creativeId/key (mandatory) provided',
            )
      },
      getBannerAsset: function _getBannerAsset(e, t) {
        window.AF_SDK.xhr({
          method: 'GET',
          withCredentials: !1,
          url: e,
          cb: function (r) {
            if (!r || !r.data) {
              var n = "fetch banner creative asset didn't return data"
              return (
                window.AF_SDK.utils.logger(
                  'Getting banner-creative asset [' +
                    e +
                    '] from the server... received, error: ',
                  n,
                ),
                t({ text: n })
              )
            }
            t(null, r.data)
          },
          fail: function (r) {
            return (
              window.AF_SDK.utils.logger(
                'Getting banner-creative asset [' +
                  e +
                  '] from the server... received, error: ',
                r,
              ),
              t(r)
            )
          },
        })
      },
    }
  },
  function (e, t, r) {
    'use strict'
    var n = r(0)
    var i = function (e, t, r) {
      for (var i = 0; i < e.length; i++) {
        var a = new Image(1, 1),
          o = n.timeLimitCallback(
            r,
            function (e) {
              e && 'error' === e.type
                ? t('Failed fetching ' + e.target.src)
                : t()
            },
            function () {
              t('Request timed out')
            },
          )
        ;(a.onload = o), (a.onerror = o), (a.src = e[i])
      }
    }
    e.exports = {
      prefetchAssets: function _prefetchAssets(e, t) {
        var r =
            window.AF_SDK.utils.getUrlParamsObject({})['af-sb-timeout'] || 1e4,
          a = !1
        if (0 === e.length) t()
        else {
          var o = n.after(e.length, function (e) {
            if (!a) {
              var r = (function _getFirstError(e) {
                if (!e) return null
                for (var t = 0; t < e.length; t++)
                  if (e[t].length) return e[t][0]
                return null
              })(e)
              r ? t(r) : t()
            }
          })
          i(e, o, r)
        }
        return function () {
          a = !0
        }
      },
    }
  },
  function (e, t, r) {
    'use strict'
    var n = r(6).inject
    e.exports = {
      render: function _render(e, t) {
        try {
          return n(e.layout, e.style, e.script, e.position, {
            mountTargetSelector: t.bannerContainerQuery,
            zIndex: t.bannerZIndex || 2147483647,
          })
        } catch (e) {
          throw (window.AF_SDK.utils.logger(e.message), e)
        }
      },
    }
  },
  function (e, t, r) {
    e.exports = { inject: r(7).inject }
  },
  function (e, t, r) {
    'use strict'
    function _resetTransform(e) {
      return function () {
        e && (e.style.transform = '')
      }
    }
    function _createElement(e, t) {
      var r = document.createElement(t || 'div')
      return (r.innerHTML = e), t ? r : r.children[0]
    }
    e.exports = {
      inject: function _inject(e, t, r, n, i) {
        var a = [],
          o = [],
          s = i && i.mountTargetSelector,
          d = i && i.zIndex
        if (!e || !t || !n)
          throw new Error('Failed to inject banner - missing arguments')
        var u = _createElement(e)
        'number' == typeof d && (u.style.zIndex = d)
        var l = (s && document.querySelector(s)) || document.body
        if (t) {
          var c = _createElement(t, 'style')
          document.head.insertBefore(c, document.head.firstChild), a.push(c)
        }
        switch (n) {
          case 'top':
            l.insertBefore(u, l.firstChild), a.push(u)
            break
          case 'top-sticky':
            ;(u.style.position = 'fixed'),
              (u.style.top = '0'),
              (u.style.right = '0'),
              (u.style.left = '0'),
              l.insertBefore(u, l.firstChild),
              ((f = document.createElement('div')).style.height =
                u.offsetHeight + 'px'),
              l.insertBefore(f, u),
              a.push(u, f)
            break
          case 'bottom':
            var f
            ;(u.style.position = 'fixed'),
              (u.style.bottom = '0'),
              (u.style.right = '0'),
              (u.style.left = '0'),
              l.appendChild(u),
              s &&
                !l.style.transform &&
                ((l.style.transform = 'translate(0)'),
                o.push(_resetTransform(l))),
              ((f = document.createElement('div')).style.height =
                u.offsetHeight + 'px'),
              l.appendChild(f),
              a.push(u, f)
            break
          case 'splash':
            ;(u.style.position = 'fixed'),
              (u.style.right = '0'),
              (u.style.left = '0'),
              l.appendChild(u),
              s &&
                !l.style.transform &&
                ((l.style.transform = 'translate(0)'),
                o.push(_resetTransform(l))),
              (u.style.top = 'calc(50% - ' + u.offsetHeight / 2 + 'px)'),
              a.push(u)
        }
        if (r) {
          var _ = _createElement(r, 'script')
          document.body.appendChild(_), a.push(_)
        }
        return (function _getCleanupFunction(e, t) {
          return function () {
            if (e)
              for (var r = 0; r < e.length; r++) {
                var n = e[r]
                n.parentNode && n.parentNode.removeChild(n)
              }
            if (t) for (r = 0; r < t.length; r++) t[r]()
          }
        })(a, o)
      },
    }
  },
  function (e, t, r) {
    'use strict'
    var n = r(1),
      i = function (e) {
        var t = new Image(1, 1)
        ;(t.style.display = 'none'),
          (t.style.position = 'absolute'),
          (t.style.left = '-1px'),
          (t.style.top = '-1px'),
          (t.src = e)
      }
    function _buildUrlForImpression(e) {
      var t = n.buildUrlQueryString(e, !1),
        r = e.url.path.match('(https:\\/\\/)(([^\\.][^\\.]+).)(.*\\/)(.*)')
      return 'https://impressions.' + r[4] + r[5] + t
    }
    e.exports = {
      buildUrlForImpression: _buildUrlForImpression,
      injectPixel: function _injectPixel(e) {
        var t = _buildUrlForImpression(e)
        return i(t)
      },
    }
  },
  function (e, t, r) {
    var n, a, o
    !(function (r) {
      var s = /iPhone/i,
        d = /iPod/i,
        u = /iPad/i,
        l = /\bAndroid(?:.+)Mobile\b/i,
        c = /Android/i,
        f = /\bAndroid(?:.+)SD4930UR\b/i,
        _ = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,
        p = /Windows Phone/i,
        g = /\bWindows(?:.+)ARM\b/i,
        w = /BlackBerry/i,
        b = /BB10/i,
        v = /Opera Mini/i,
        h = /\b(CriOS|Chrome)(?:.+)Mobile/i,
        y = /Mobile(?:.+)Firefox\b/i
      function m(e, t) {
        return e.test(t)
      }
      function i(e) {
        var t =
            e || ('undefined' != typeof navigator ? navigator.userAgent : ''),
          r = t.split('[FBAN')
        void 0 !== r[1] && (t = r[0]),
          void 0 !== (r = t.split('Twitter'))[1] && (t = r[0])
        var n = {
          apple: {
            phone: m(s, t) && !m(p, t),
            ipod: m(d, t),
            tablet: !m(s, t) && m(u, t) && !m(p, t),
            device: (m(s, t) || m(d, t) || m(u, t)) && !m(p, t),
          },
          amazon: {
            phone: m(f, t),
            tablet: !m(f, t) && m(_, t),
            device: m(f, t) || m(_, t),
          },
          android: {
            phone: (!m(p, t) && m(f, t)) || (!m(p, t) && m(l, t)),
            tablet: !m(p, t) && !m(f, t) && !m(l, t) && (m(_, t) || m(c, t)),
            device:
              (!m(p, t) && (m(f, t) || m(_, t) || m(l, t) || m(c, t))) ||
              m(/\bokhttp\b/i, t),
          },
          windows: {
            phone: m(p, t),
            tablet: m(g, t),
            device: m(p, t) || m(g, t),
          },
          other: {
            blackberry: m(w, t),
            blackberry10: m(b, t),
            opera: m(v, t),
            firefox: m(y, t),
            chrome: m(h, t),
            device: m(w, t) || m(b, t) || m(v, t) || m(y, t) || m(h, t),
          },
        }
        return (
          (n.any =
            n.apple.device ||
            n.android.device ||
            n.windows.device ||
            n.other.device),
          (n.phone = n.apple.phone || n.android.phone || n.windows.phone),
          (n.tablet = n.apple.tablet || n.android.tablet || n.windows.tablet),
          n
        )
      }
      e.exports && 'undefined' == typeof window
        ? (e.exports = i)
        : e.exports && 'undefined' != typeof window
        ? ((e.exports = i()), (e.exports.isMobile = i))
        : ((a = []),
          (n = r.isMobile = i()),
          void 0 === (o = 'function' == typeof n ? n.apply(t, a) : n) ||
            (e.exports = o))
    })(this)
  },
]

export function init() {
  script(e)
}
